import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "MODAL_SLICE",
  initialState: {
    // Перенесем сюда все основные модалки и состояния
    AgentBanksChronhologyModal: {
      isOpen: false,
    },
    AgentChronhologyModal: {
      isOpen: false,
      bank_id: undefined,
    },
    BankChronhologyModal: {
      isOpen: false,
      bank_id: undefined,
    },
  },
  reducers: {
    /* модалка для добавления банка агенту */
    OPEN_AGENT_BANKS_CHRONOLOGY_MODAL: (state) => {
      state.AgentBanksChronhologyModal.isOpen = true;
    },
    CLOSE_AGENT_BANKS_CHRONOLOGY_MODAL: (state) => {
      state.AgentBanksChronhologyModal.isOpen = false;
    },
    /* модалка с хронологией для агента */
    OPEN_AGENT_CHRONOLOGY_MODAL: (state) => {
      state.AgentChronhologyModal.isOpen = true;
    },
    CLOSE_AGENT_CHRONOLOGY_MODAL: (state) => {
      state.AgentChronhologyModal.bank_id = undefined;
      state.AgentChronhologyModal.isOpen = false;
    },
    SET_BANKID_AGENT_CHRONOLOGY_MODAL: (state, action) => {
      state.AgentChronhologyModal.bank_id = action.payload;
    },
    /* модалка с хронологией для банка */
    OPEN_BANK_CHRONOLOGY_MODAL: (state) => {
      state.BankChronhologyModal.isOpen = true;
    },
    CLOSE_BANK_CHRONOLOGY_MODAL: (state) => {
      state.BankChronhologyModal.bank_id = undefined;
      state.BankChronhologyModal.isOpen = false;
    },
    SET_BANKID_BANK_CHRONOLOGY_MODAL: (state, action) => {
      state.AgentChronhologyModal.bank_id = action.payload;
    },
  },
});

export const {
  OPEN_AGENT_BANKS_CHRONOLOGY_MODAL,
  CLOSE_AGENT_BANKS_CHRONOLOGY_MODAL,
  OPEN_AGENT_CHRONOLOGY_MODAL,
  CLOSE_AGENT_CHRONOLOGY_MODAL,
  SET_BANKID_AGENT_CHRONOLOGY_MODAL,
  OPEN_BANK_CHRONOLOGY_MODAL,
  CLOSE_BANK_CHRONOLOGY_MODAL,
  SET_BANKID_BANK_CHRONOLOGY_MODAL,
} = modalSlice.actions;

export default modalSlice.reducer;
